import { Component, inject, OnInit } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { NgxSpinnerComponent } from "ngx-spinner";

@Component({
    selector: "app-root",
    imports: [RouterOutlet, NgxSpinnerComponent],
    templateUrl: "./app.html",
    styleUrl: "./app.scss",
})
export class App implements OnInit {
    private iconRegistry = inject(MatIconRegistry);
    private sanitizer = inject(DomSanitizer);

    ngOnInit(): void {
        const icons: { name: string; path: string }[] = [
            { name: "dashboard", path: "/assets/icons/dashboard.svg" },
            { name: "dashboard_active", path: "/assets/icons/dashboard-active.svg" },
            { name: "policy_declaration", path: "/assets/icons/policy-declaration.svg" },
            { name: "policy_declaration_active", path: "/assets/icons/policy-declaration-active.svg" },
            { name: "protection_catalog", path: "/assets/icons/protection-catalog.svg" },
            { name: "protection_catalog_active", path: "/assets/icons/protection-catalog-active.svg" },
            { name: "branch_management", path: "/assets/icons/branch-management.svg" },
            { name: "branch_management_active", path: "/assets/icons/branch-management-active.svg" },
            { name: "upload_here", path: "/assets/icons/upload-here.svg" },
            { name: "download_coc", path: "/assets/icons/download-coc.svg" },
            { name: "product_management", path: "/assets/icons/product-management.svg" },
            { name: "product_management_active", path: "/assets/icons/product-management-active.svg" },
        ];

        for (const { name, path } of icons) {
            this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(path));
        }
    }
}
